import { render, staticRenderFns } from "./W0147V0001.vue?vue&type=template&id=23f309c6&"
import script from "./W0147V0001.vue?vue&type=script&lang=js&"
export * from "./W0147V0001.vue?vue&type=script&lang=js&"
import style0 from "./W0147V0001.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports